import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUserForLicenseAsyncModule } from '@portal-core/license-users/pipes/license-user-for-license-async/license-user-for-license-async.module';
import { SnackBarErrorModule } from '@portal-core/ui/snack-bar/components/snack-bar-error/snack-bar-error.module';
import { WorkspaceFileUserStatusAvatarIndicatorModule } from '@portal-core/workspaces/components/workspace-files-user-status-avatar-indicator/workspace-file-user-status-avatar-indicator.module';
import { WorkspaceFilesUserStatusListCurrentUserWarningModule } from '@portal-core/workspaces/directives/workspace-files-user-status-list-current-user-warning/workspace-files-user-status-list-current-user-warning.module';
import { WorkspaceFilesUserStatusListWarningModule } from '@portal-core/workspaces/directives/workspace-files-user-status-list-warning/workspace-files-user-status-list-warning.module';
import { WorkspaceFilesUserStatusListComponent } from './workspace-files-user-status-list.component';

@NgModule({
  declarations: [WorkspaceFilesUserStatusListComponent],
  imports: [
    CommonModule,
    IncludedInModule,
    LicenseUserAvatarModule,
    LicenseUserForLicenseAsyncModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    SnackBarErrorModule,
    WorkspaceFileUserStatusAvatarIndicatorModule,
    WorkspaceFilesUserStatusListCurrentUserWarningModule,
    WorkspaceFilesUserStatusListWarningModule
  ],
  exports: [
    WorkspaceFilesUserStatusListComponent,
    WorkspaceFilesUserStatusListCurrentUserWarningModule,
    WorkspaceFilesUserStatusListWarningModule
  ]
})
export class WorkspaceFilesUserStatusListModule { }
